import React from 'react';
import { FormattedMessage } from 'react-intl';
import { compose } from 'ramda';
import { lifecycle, withHandlers } from 'recompose';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import S from 'app/features/billing/components/Billing/Billing.styled';
import BasicLink from 'app/components/Links/BasicLink.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import CheckoutButton from 'app/features/billing/components/Billing/CheckoutButton';
import FloatingLayout from 'app/components/layout/FloatingLayout';
import BackgroundImage from 'app/features/billing/components/Billing/BackgroundImage';
import Text from 'app/components/layout/Text.styled';
import { planBySelectedProduct } from 'app/features/plans/selectors';
import {
  billingPlanReset,
  billingPlanSelected,
} from 'app/features/billing/actions';
import Heading from 'app/components/layout/Heading.styled';
import SubscriptionTitle from 'app/features/billing/components/Billing/SubscriptionTitle';
import { PRODUCT_COMPARISON_ANCHOR_PLANS } from 'app/features/landing/productComparison/constants';
import { localRedirect } from 'app/router/actions';

const UI = ({ onClick }) => (
  <FloatingLayout>
    <FloatingLayout.ContentBlock>
      <S.Billing>
        <BackgroundImage />
        <S.ContentWrapper>
          <Heading size="xl" as={S.Title} type="heavy">
            <FormattedMessage id="billing_subscribe_title_default" />
          </Heading>
          <Text as={S.Subtitle} size="xl">
            <FormattedMessage
              id="billing_subscribe_subtitle_default"
              values={{
                anotherPlanCTA: (
                  <BasicLink
                    testId="billing-choose-another-plan-link"
                    as={LocalizedLink}
                    onClick={onClick}
                    to={PRODUCT_COMPARISON_ANCHOR_PLANS}
                  >
                    <FormattedMessage id="billing_subscribe_title_link_default" />
                  </BasicLink>
                ),
                subscription_title: <SubscriptionTitle />,
                linebreak: <br />,
              }}
            />
          </Text>
          <S.ButtonHolder>
            <CheckoutButton
              testId="billing-continue-to-checkout"
              textKey="buttons_billing_subscribe"
            />
          </S.ButtonHolder>
        </S.ContentWrapper>
      </S.Billing>
    </FloatingLayout.ContentBlock>
  </FloatingLayout>
);

UI.propTypes = { onClick: PropTypes.func.isRequired };

UI.displayName = 'NoBillingPlanChoice';

const state = { planBySelectedProduct };

const actions = { billingPlanSelected, billingPlanReset };

const onClick =
  ({ dispatch }) =>
  () =>
    dispatch(localRedirect(PRODUCT_COMPARISON_ANCHOR_PLANS));

function componentDidMount() {
  const { billingPlanSelected, planBySelectedProduct } = this.props;

  billingPlanSelected(planBySelectedProduct);
}

function componentDidUpdate() {
  const { billingPlanSelected, planBySelectedProduct } = this.props;

  billingPlanSelected(planBySelectedProduct);
}

function componentWillUnmount() {
  this.props.billingPlanReset();
}

const NoBillingPlanChoice = compose(
  connect(state, actions),
  lifecycle({ componentDidMount, componentDidUpdate, componentWillUnmount }),
  withHandlers({ onClick }),
)(UI);

export {
  UI,
  componentDidMount,
  componentDidUpdate,
  componentWillUnmount,
  onClick,
};

export default NoBillingPlanChoice;
